import { ToolType } from '@cognite/unified-file-viewer';
import { ToolbarToolOption } from './components/Toolbar';

export const ToolBarSettings: ToolbarToolOption[] = [
  { type: ToolType.PAN, icon: 'Grab' },
  { type: ToolType.SELECT, icon: 'Cursor' },
  { type: ToolType.RECTANGLE, icon: 'AddLarge' },
  { type: ToolType.POLYLINE, icon: 'Polygon' },
];
